import { useQuery } from 'react-query';

import { getTemplateNames as queryFn } from 'api/endPoints/getTemplateNames';
import { QueryKeys } from 'api/queryKeys';

import { ITemplate } from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';

export const useQueryPhasePerformanceGetTemplates = () => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getTemplateNames'],
        queryFn: () => queryFn(),
    });
};

export interface QueryResponse {
    info: IToolTip;
    templates: ITemplate[];
}
